import { render, staticRenderFns } from "./selection_questions.vue?vue&type=template&id=4c121400&scoped=true&"
import script from "./selection_questions.vue?vue&type=script&lang=js&"
export * from "./selection_questions.vue?vue&type=script&lang=js&"
import style0 from "./selection_questions.vue?vue&type=style&index=0&id=4c121400&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c121400",
  null
  
)

export default component.exports